import React, { useState } from "react";
import PropTypes from "prop-types";
import { deleteUnit } from "../../api/unit/unit";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import styled from "styled-components";
import ConfirmDeleteModal from "../ConfirmDeleteModal/ConfirmDeleteModal";

const InlineDeleteButton = styled.button`
	background-color: rgb(202, 91, 79);
	color: white;
	border: none;
	border-radius: 10rem;
	padding: 0.5rem 1.2rem;
	font-size: 1.2rem;
	font-weight: 500;
	line-height: 1.2;
	margin-right: 1.8rem;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 2.4rem;
	vertical-align: middle;
	transform: translateY(-10px);

	&:hover {
		background-color: #c0392b;
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.4);
	}
`;

const DeleteUnitButton = ({ unitId, unitName, onDeleted }) => {
	const { axiosPrivate } = useAxiosPrivate();
	const [modalOpen, setModalOpen] = useState(false);

	const handleDelete = async () => {
		try {
			const res = await deleteUnit(axiosPrivate, unitId);
			if (res && onDeleted) {
				onDeleted();
			}
		} catch (err) {
			console.error("Delete failed:", err);
			alert("Failed to delete unit.");
		} finally {
			setModalOpen(false);
		}
	};

	return (
		<>
			<InlineDeleteButton
				onClick={() => setModalOpen(true)}
				aria-label={`Delete unit ${unitName}`}
			>
				Delete
			</InlineDeleteButton>

			<ConfirmDeleteModal
				isOpen={modalOpen}
				onRequestClose={() => setModalOpen(false)}
				onConfirm={handleDelete}
				title="Confirm deletion of unit"
				message={`Are you sure you want to delete the unit "${unitName}"?\nThis action cannot be undone, and all related information will be permanently removed.`}
				confirmLabel="Yes, delete unit"
			/>
		</>
	);
};

DeleteUnitButton.propTypes = {
	unitId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	unitName: PropTypes.string.isRequired,
	onDeleted: PropTypes.func,
};

export default DeleteUnitButton;
